import { Dictionary } from ".";

export function replaceStringVariables(input: string, variables?: Dictionary<string | number>): string {
    if (!variables) return input;

    let value = input;

    Object.keys(variables).forEach((k) => {
        value = value.split(`{${k}}`).join(variables[k].toString());
    });

    return value;
}